import { useReadAloud } from '@3plearning/question-components-library';
import { useState, useEffect } from 'react';

import Resources from '../../../../helpers/resources';
import { getValueFromUrl } from '../../../../helpers/utils';

export const useTts = () => {
  const [readAloudConfig, setReadAloudConfig] = useState({
    enabled: false,
    gatewayUrl: window._env_.ReadAloudGatewayUrl,
    token: Resources.env.authToken,
    locale: 'en-AU'
  });

  const onLocaleChange = (locale) => {
    setReadAloudConfig({
      ...readAloudConfig,
      locale
    });
  };

  const onToggleEnableState = (enabled) => {
    setReadAloudConfig({
      ...readAloudConfig,
      enabled: !enabled
    });
  };

  const { setReadAloudConfig: setQCLReadAloudConfig, setTranscriptModalInitialPosition } = useReadAloud();

  useEffect(() => {
    const localeFromUrl = getValueFromUrl('locale') || 'en-AU';
    const locale = /es-/ig.test(localeFromUrl) ? 'es-US' : localeFromUrl;

    setQCLReadAloudConfig(prevConfig => ({
      ...prevConfig,
      locale
    }));

    setTranscriptModalInitialPosition({
      left: Math.max(window.innerWidth - 520, 0),
      top: 80
    });
  }, []);

  return { readAloudConfig, onLocaleChange, onToggleEnableState };
};
